// src/components/PeoplePlan/TheBench/components/WorkflowKanban/KanbanColumn.js
import React from "react";
import { useDroppable } from "@dnd-kit/core";
import KanbanCard from "./KanbanCard";

const KanbanColumn = ({ status, employees, onEmployeeSelect }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: status,
  });

  const employeeCount = employees.length;

  return (
    <div
      ref={setNodeRef}
      className={`kanban-column ${isOver ? "highlight-drop" : ""}`}
    >
      <h2>
        {status}
        <span className="column-count">{employeeCount}</span>
      </h2>
      <div className="cards-container">
        {employees.length === 0 ? (
          <p className="empty-message">No employees</p>
        ) : (
          employees.map((employee) => (
            <KanbanCard
              key={employee.user_id}
              employee={employee}
              onEmployeeSelect={onEmployeeSelect}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default KanbanColumn;